import React from 'react';
import {ButtonDropdown, DropdownList} from '@forecast-it/design-system';
import {FormattedMessage} from 'react-intl';

type ChangeViewButtonProps = {
	children: React.JSX.Element | React.ReactElement[];
};

const ChangeViewButton = ({children}: ChangeViewButtonProps): React.JSX.Element => {
	return (
		<DropdownList>
			<DropdownList.Trigger>
				<ButtonDropdown emphasis={'medium'} data-cy={'change-view'}>
					<FormattedMessage id={'change_view.button'} />
				</ButtonDropdown>
			</DropdownList.Trigger>
			<DropdownList.Content offset={4}>{children}</DropdownList.Content>
		</DropdownList>
	);
};

export default ChangeViewButton;
